import type { CSSProperties, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import SidebarButton from './SidebarButton';
import { classes } from './utils';

export { SidebarButton };

export type SidebarProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

export default function Sidebar({ className, style, children }: SidebarProps) {
  return (
    <div style={style} className={twMerge(classes.wrapper, className)}>
      <aside className={classes.rail}>{children}</aside>
    </div>
  );
}
